module.exports = __webpack_public_path__ + "img/4.d2a71412.jpg";